import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import OutsideClickListener from "sprout-ui-dom/dist/internal/OutsideClickListener";
import { CSSTransitionPortal } from "sprout-ui-dom/dist/Portal";
import DialogContextualActionBar from "./Dialog_ContextualActionBar";
import { DialogRoot, DialogWrapper } from "./styles";
import useDialogOverlayHandlers from "./useDialogOverlayHandlers";
const dialogTimeout = {
    enter: 0,
    exit: 0
};
const Dialog = (props)=>{
    const { variant , onExited: onExitedProp , children , open , onRequestClose , contextualTitle , leftAction , rightAction , hideContextualActionBar ,  } = props;
    const { onEnter , onExited  } = useDialogOverlayHandlers();
    const handleExited = useCallback((node)=>{
        onExited();
        if (onExitedProp) onExitedProp(node);
    }, [
        onExited,
        onExitedProp
    ]);
    return /*#__PURE__*/ _jsx(CSSTransitionPortal, {
        open: open,
        timeout: dialogTimeout,
        onEnter: onEnter,
        onExited: handleExited,
        children: /*#__PURE__*/ _jsx(OutsideClickListener, {
            onOutsideClick: onRequestClose,
            children: /*#__PURE__*/ _jsx(DialogRoot, {
                $variant: variant,
                children: /*#__PURE__*/ _jsxs(DialogWrapper, {
                    $variant: variant,
                    children: [
                        /*#__PURE__*/ _jsx(DialogContextualActionBar, {
                            hideContextualActionBar: hideContextualActionBar,
                            contextualTitle: contextualTitle,
                            leftAction: leftAction,
                            rightAction: rightAction
                        }),
                        children
                    ]
                })
            })
        })
    });
};
export default Dialog;
